export const configData =  {  

    APP_URL: "/basic/web/api/",
    DOMAIN_URL: "https://rsmww.preferati.net/basic/web/",
    DRUPAL_APP_URL: "https://betasmww.preferati.net/api/",
    DRUPAL_DOMAIN_URL: "https://betasmww.preferati.net",
    AGENCY_DOMAIN_URL: "https://betasmwwagency.preferati.net",
    SCOUT_DOMAIN_URL: "https://betasmwwscout.preferati.net",
    RSMWW_DOMAIN: "rsmww.preferati.net",
    RSMWW_AGENCY_DOMAIN: "rsmwwagency.preferati.net",
    RSMWW_SCOUT_DOMAIN: "rsmwwscout.preferati.net",
    RSMWW_AGENCY_URL: "https://rsmwwagency.preferati.net",
    RSMWW_SCOUT_URL: "https://rsmwwscout.preferati.net",
    GOOGLE_RECAPTCHA_SITE_KEY: '6Ld4sRcsAAAAAExeVnOiq6zy_NtSheLSx4FiJRCI',
    //GOOGLE_RECAPTCHA_SITE_KEY: '6LeUZTYsAAAAAOl-sjYYG5jRdVv8MsvQ0rOajT_Q',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`,
    ROLE_ADMINISTRATOR: 3,
    ROLE_SAADMIN: 8,
    ROLE_SALES_PEOPLE:10,
    ROLE_SALES_DIRECTOR:18,
    ROLE_APPLICATION:12,
    ROLE_GLOBAL_AMBASSADOR:27,
    ROLE_AGENT:6,
    ROLE_SCOUT:5,
    ROLE_ATHLETE:11,
    ROLE_MENTOR:7,
    ROLE_AUTHENTICATED_USER:2
     }